module.exports = __webpack_public_path__ + "img/6.b241b74b.png";